import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestJobsGet = {
    path: "/jobs",
    method: RouteHttpVerb.GET
};
